import {get, post} from './api';
const getCourses = get('course/list');
const getNormalCourse = get('course/free-list');
const getCourse = get('course/get');
const saveCourse = post('course/save');
const updateLessonSchedule = post('course/update-lesson-schedule');
const getCourseMembers = get('course/members');

export {
    getCourses,
    getCourse,
    saveCourse,
    updateLessonSchedule,
    getCourseMembers,
    getNormalCourse
}
